import React, { useState } from "react";
import Icons from "./Icons";
import { TextInput, View, Button } from "./Themed";
import { useColors } from "../constants/useColors";

type SearchBoxProps = {
    onSearch?: (text:string) => void,
    onChange? : (text:string) => void,
    hide_search_button?:boolean,
    placeholder?: string,
    onFocusPosition?:(pos:{ x:number, y:number, height:number, width:number }) => void,
    style?:any,
    button_style?:any
}

const SearchBox = ({ placeholder, onSearch, onChange, hide_search_button, style, onFocusPosition, button_style }:SearchBoxProps) => {
    const [ search_value, setSearchValue ] = useState('');
    const Colors = useColors();
    const handleSearch = () => {
        if(!onSearch){ return }
        if(search_value == ''){ return alert('Please provide search value') }
        onSearch(search_value)
        setSearchValue('')
    }

    return (
        <View transparent style={{ flexDirection:'row', alignItems:'center', padding:5 }}>
            <View type='input' style={{ flex:1, flexDirection:'row', alignItems:'center', marginRight:10 }}>
                <View transparent style={{ padding:10 }}>
                    <Icons.SearchIcon size={12} color={Colors.text.h1} />
                </View>
                <TextInput
                    placeholder={placeholder ?? 'Search'}
                    value={search_value}
                    transparent
                    onFocusPosition={onFocusPosition}
                    placeholderTextColor={Colors.text.descriptionLight}
                    style={{ flex:1, ...style }}
                    onChangeText={(text) => {
                        setSearchValue(text)
                        if(onChange){ onChange(text) }
                    }}
                />
            </View>
            {!hide_search_button ?
            <Button
                title="Search"
                style={button_style}
                type='info'
                onPress={() => handleSearch()}
            />
            :<></>}
        </View>
    )
}

export default SearchBox